import React from 'react';
import {Loader, Table} from 'semantic-ui-react';

export const LoaderDetailList = () => {
  return (
    <Table.Row textAlign='center'>
      <Table.Cell colSpan={6}>
        <Loader active inline='centered'>
          Consultando...
        </Loader>
      </Table.Cell>
    </Table.Row>
  );
};
